<div class="di" [class.di--compact]="compact">
    <input
        class="form-field-input di__amount"
        type="number"
        min="0"
        step="any"
        [id]="inputId"
        [attr.aria-label]="label || null"
        [class.di__invalid]="invalid || isInvalid"
        [placeholder]="placeholder"
        [ngModel]="amount"
        (ngModelChange)="setAmount($event)"
        (blur)="blurred.emit()"
        [disabled]="disabled"
    />
    <select
        class="form-field-input di__unit"
        [id]="inputId + 'Unit'"
        [attr.aria-label]="(label ? label + ' ' : '') + 'unit'"
        [ngModel]="unit"
        (ngModelChange)="setUnit($event)"
        (blur)="blurred.emit()"
        [disabled]="disabled"
    >
        @for (option of units; track option.value) {
        <option [ngValue]="option.value">{{ option.label }}</option>
        }
    </select>
</div>
